import { render } from "./PublicMenu.vue?vue&type=template&id=7b577f8e&scoped=true"
import script from "./PublicMenu.vue?vue&type=script&lang=js"
export * from "./PublicMenu.vue?vue&type=script&lang=js"

import "./PublicMenu.vue?vue&type=style&index=0&id=7b577f8e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b577f8e"]])

export default __exports__